module.exports = __webpack_public_path__ + "static/media/image_forum_home.40afc7d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/image_forum_home.svg
// module id = 440
// module chunks = 0